export const IMAGES = {
  heroPortrait:
    "https://images.pexels.com/photos/10350352/pexels-photo-10350352.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720",
  jawCard:
    "https://images.unsplash.com/photo-1771896768694-27a086335458?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxhdGhsZXRpYyUyMG1hbiUyMHByb2ZpbGUlMjBqYXdsaW5lJTIwcG9ydHJhaXQlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3OTAxMDk2Nzd8MA&ixlib=rb-4.1.0&q=85",
  manifestoSpot:
    "https://images.unsplash.com/photo-1741211699653-5e90542f9cda?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxhdGhsZXRpYyUyMG1hbiUyMHByb2ZpbGUlMjBqYXdsaW5lJTIwcG9ydHJhaXQlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3OTAxMDk2Nzd8MA&ixlib=rb-4.1.0&q=85",
  steak:
    "https://images.pexels.com/photos/618775/pexels-photo-618775.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  rawMeat:
    "https://images.unsplash.com/photo-1783632666729-fbfb2ed5516a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxyYXclMjBzdGVhayUyMGJ1dGNoZXIlMjBiZWVmJTIwd2hvbGUlMjBmb29kJTIwb3JnYW5pYyUyMG51dHJpdGlvbnxlbnwwfHx8fDE3OTAxMDk2Nzd8MA&ixlib=rb-4.1.0&q=85",
  ancestralFoods:
    "https://images.pexels.com/photos/5463882/pexels-photo-5463882.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  gymDark:
    "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtYXNjdWxpbmUlMjBsaWZlc3R5bGUlMjBkYXJrJTIwYWVzdGhldGljJTIwZml0bmVzcyUyMGd5bSUyMG1hbnxlbnwwfHx8fDE3OTAxMDk2Nzd8MA&ixlib=rb-4.1.0&q=85",
  torso:
    "https://images.pexels.com/photos/8875089/pexels-photo-8875089.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  avatar1:
    "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=160&q=80",
  avatar2:
    "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=160&q=80",
  avatar3:
    "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?auto=format&fit=crop&w=160&q=80",
};

export const MARQUEE_ITEMS = [
  "ANCESTRAL NUTRITION",
  "JAWLINE ARCHITECTURE",
  "ZERO SEED OILS",
  "MASSETER STRENGTH",
  "REAL FOOD ONLY",
  "HARD CHEW DAILY",
  "TONGUE ON THE ROOF",
  "BUILT, NOT BOUGHT",
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Your face is a report card",
    body: "Two generations ago men chewed tough, fibrous food for hours a day. Their masseter muscles grew, their jaws widened, their faces had structure. Then food went soft — blended, extruded, packaged. Faces followed. The softness you see in the mirror is not genetics. It is diet, posture and underuse, accumulated daily.",
    stat: "70%",
    statLabel: "of the modern UK diet is now ultra-processed — and faces show it",
  },
  {
    num: "02",
    title: "The masseter is a muscle. Train it.",
    body: "The masseter is the strongest muscle in the human body relative to its size — and like every muscle, it responds to progressive resistance. Hard, deliberate chewing loads it. Tongue posture shapes the bone beneath it. We treat the jaw like any other lift: structured volume, tracked over 12-week cycles.",
    stat: "40min",
    statLabel: "of deliberate hard chewing, daily — the club baseline",
  },
  {
    num: "03",
    title: "Food is information",
    body: "Industrial seed oils and ultra-processed calories drive the inflammation and fat distribution that blur every angle of your face. Real food — meat, eggs, fish, fruit, dairy, salt — does the opposite. We don't count calories. We delete factories from the supply chain and eat what a human is built to eat.",
    stat: "0",
    statLabel: "seed oils. Not 'in moderation'. Zero.",
  },
];

export const PROGRAMS = [
  {
    id: "jawline",
    index: "P.01",
    title: "Jawline Architecture",
    tag: "MASSETER PROTOCOL",
    image: "jawCard",
    description:
      "A progressive resistance programme for the most visible muscle you own. Hard-chew loading, tongue posture, neck structure — tracked in 12-week cycles.",
    points: [
      "Hard-chew progression — from tough whole foods to structured resistance work",
      "All-day tongue posture: the mewing baseline, corrected and held",
      "Neck and posture block — the frame the jaw hangs from",
      "Photo tracking every 4 weeks. Angles don't lie",
    ],
  },
  {
    id: "fuel",
    index: "P.02",
    title: "Ancestral Fuel",
    tag: "REAL-FOOD PROTOCOL",
    image: "steak",
    description:
      "An elimination-first nutrition blueprint. Remove the industrial inputs, keep the foods your face was built on. No calorie apps. No powders.",
    points: [
      "Seed-oil elimination — the 8 industrial oils, and everywhere they hide",
      "The whole-food plate: meat, eggs, fish, fruit, raw dairy, salt",
      "Cook in tallow, butter, ghee. Never from a plastic bottle",
      "The label rule: more than 5 ingredients, it goes back on the shelf",
    ],
  },
];

export const ASSESSMENT_QUESTIONS = [
  {
    q: "How much of your weekly food is ultra-processed?",
    options: [
      { label: "Almost everything — packets, takeaways, fizzy drinks", score: 0 },
      { label: "More than I'd like to admit", score: 1 },
      { label: "Occasionally — weekends, mostly", score: 2 },
      { label: "Almost none. I cook real food", score: 3 },
    ],
  },
  {
    q: "How defined is your jawline right now?",
    options: [
      { label: "Soft — it blends straight into my neck", score: 0 },
      { label: "A faint shadow in good lighting", score: 1 },
      { label: "A visible angle from the side", score: 2 },
      { label: "Sharp. It cuts through t-shirts", score: 3 },
    ],
  },
  {
    q: "How often does your jaw meet real resistance?",
    options: [
      { label: "Never — soft food only", score: 0 },
      { label: "Chewing gum now and then", score: 1 },
      { label: "Tough food daily — steak, jerky, crusts", score: 2 },
      { label: "Structured hard-chew training, daily", score: 3 },
    ],
  },
  {
    q: "Where does your cooking fat come from?",
    options: [
      { label: "Whatever's in the fryer, or a bottle of vegetable oil", score: 0 },
      { label: "A mix — olive oil and seed oils", score: 1 },
      { label: "Mostly olive oil or butter", score: 2 },
      { label: "Tallow, butter, ghee — animal fats only", score: 3 },
    ],
  },
];

export const ASSESSMENT_TIERS = [
  {
    max: 4,
    name: "SOFT RESET",
    verdict:
      "Your inputs are working against you. Soft food and industrial oils have had years to blur your structure — the good news is the turnaround starts the day you stop feeding it.",
    protocol: [
      "Weeks 1–2: delete seed oils and anything in a crinkly packet. No exceptions.",
      "Weeks 1–12: 10 minutes of deliberate hard chewing daily, building to 40.",
      "Fix tongue posture — teeth lightly touching, tongue flat on the palate, lips closed.",
    ],
  },
  {
    max: 8,
    name: "BUILD PHASE",
    verdict:
      "The foundations exist but they're inconsistent. You have angle to work with — now it needs load, and your diet needs the last industrial inputs stripped out.",
    protocol: [
      "20–30 minutes of structured chew work, 6 days a week. Track it.",
      "Audit your kitchen: swap every liquid oil for tallow, butter or ghee this week.",
      "Take your baseline side-profile photo today. Compare at week 12.",
    ],
  },
  {
    max: 11,
    name: "SHARPENING PHASE",
    verdict:
      "You're close. The structure is there — this phase is about definition: progressive overload on the masseter and zero leakage in the diet.",
    protocol: [
      "40 minutes daily hard-chew volume, with resistance progression every 3 weeks.",
      "Full elimination audit — restaurants, sauces and 'healthy' snacks are your leak points.",
      "Add the neck and posture block to frame the angle you've built.",
    ],
  },
  {
    max: 12,
    name: "MAINTENANCE MODE",
    verdict:
      "This is the standard the club holds. Keep the inputs clean, keep the jaw loaded, and the structure keeps itself. Your job now is to not slip.",
    protocol: [
      "Hold daily chew volume at 30+ minutes. Structure is rented — rent is due daily.",
      "One photo check-in per month. Angles drift before you notice.",
      "Bring one other man up to standard. That's the club.",
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Callum R.",
    meta: "26 — Manchester — 12 weeks",
    metric: "+4.8°",
    metricLabel: "gonial angle definition",
    quote:
      "I thought my jaw was genetics. Twelve weeks of hard chewing and real food and my side profile is a different person. The photo comparison sold me.",
    avatar: "avatar1",
  },
  {
    name: "Dane W.",
    meta: "31 — London — 6 months",
    metric: "-92%",
    metricLabel: "ultra-processed intake",
    quote:
      "Deleting seed oils did more for my face than any skincare routine ever touched. Less puffiness, actual cheekbones, energy through the roof.",
    avatar: "avatar2",
  },
  {
    name: "Josh T.",
    meta: "22 — Leeds — 16 weeks",
    metric: "40min",
    metricLabel: "daily chew volume, held",
    quote:
      "The protocol is boring in the best way. Chew hard, eat real, sleep. Four months in and people keep asking if I lost weight. I didn't — my face just showed up.",
    avatar: "avatar3",
  },
];

export const FAQS = [
  {
    q: "What exactly is BP Club?",
    a: "A UK club for men rebuilding two things the modern world softened: the jawline and the diet. We publish the protocols — masseter training and ancestral, real-food eating — and members run them in 12-week cycles, tracking results with photos. No supplements, no surgery, no nonsense.",
  },
  {
    q: "Does chewing actually change your jawline?",
    a: "The masseter is skeletal muscle. Like your bicep, it grows under progressive resistance — and a developed masseter visibly widens and sharpens the lower face. Chewing also builds the habit of closed-lip, tongue-on-palate posture that shapes how the whole jaw sits. It's not overnight. It's 12-week cycles, like any training.",
  },
  {
    q: "What is mewing, and do I need it?",
    a: "Mewing is simply correct oral posture: tongue flat against the roof of the mouth, teeth lightly touching, lips sealed, breathing through the nose. It's not an exercise — it's the default position your face was designed around. Yes, you need it. It costs nothing and runs all day.",
  },
  {
    q: "Why are seed oils the enemy?",
    a: "Rapeseed, sunflower, soybean and the other industrial oils are in nearly every processed food and restaurant fryer. They're unstable, inflammatory inputs that humans ate in trace amounts for all of history until about 100 years ago. The club's position is simple: cook in animal fat or don't cook in oil at all. Your face — and the rest of you — de-puffs within weeks.",
  },
  {
    q: "What does a day of eating actually look like?",
    a: "Steak and eggs. Fish and potatoes cooked in butter. Fruit, raw cheese, honey, full-fat yoghurt if you tolerate dairy. Salt everything. The rule isn't a calorie target — it's a sourcing rule: if it needed a factory, it isn't food.",
  },
  {
    q: "How long until I see results?",
    a: "De-puffing from cutting seed oils and ultra-processed food: 2–4 weeks. Visible masseter development: 8–12 weeks of consistent chew volume. Structural change to how your jaw presents: 6 months. Take the side-profile photo on day one — you'll want it.",
  },
  {
    q: "Is this medical advice?",
    a: "No. BP Club publishes training and nutrition protocols built on basic physiology and ancestral eating principles. We're not doctors and nothing here replaces one. If you have a jaw disorder, TMJ issues, or a medical condition, talk to a professional before loading your jaw.",
  },
];

export const ARTICLES = [
  {
    slug: "seed-oil-sabotage",
    title: "The Seed Oil Sabotage",
    category: "NUTRITION",
    readTime: "6 MIN READ",
    image: "rawMeat",
    excerpt:
      "A hundred years ago these oils were machine lubricant. Today they're in everything you eat — and your face is wearing the evidence.",
    blocks: [
      {
        paragraphs: [
          "In 1890, the average Brit ate essentially zero industrial seed oil. Today the figure is close to three tablespoons a day, hidden in crisps, sauces, bread, takeaway fryers and every 'plant-based' alternative on the shelf. It is the single largest change to the human diet in recorded history — and almost nobody consented to it.",
          "The club's position doesn't require a biochemistry degree. Rapeseed, sunflower, soybean, corn, cottonseed, grapeseed, rice bran and safflower oils are extracted with heat, pressure and solvents from seeds that were never food. They are industrial products wearing a health halo.",
        ],
      },
      {
        heading: "What it does to a face",
        paragraphs: [
          "Chronic low-grade inflammation doesn't announce itself with a fever. It shows up as puffiness under the eyes, a softened jaw-neck border, skin that never quite settles. Members consistently report the same sequence when they eliminate seed oils: within two weeks the face looks 'slept-on'. Within six, the underlying structure starts showing through.",
          "Is that purely the oil? Partly it's everything the oil travels with — ultra-processed food is a delivery system. Cut the oil and you cut the vehicle by definition.",
        ],
      },
      {
        heading: "The elimination protocol",
        paragraphs: [
          "One: purge the kitchen. Every bottle of liquid cooking oil except olive oil goes in the bin. Two: learn the aliases — 'vegetable oil' on a UK label is almost always rapeseed. Three: accept that restaurant food is fried in seed oil unless stated otherwise, and order accordingly: grilled, never fried.",
          "Replace with fats that were food before they were products: beef tallow, butter, ghee. Your great-grandfather's chip pan ran on dripping. His jawline thanked him for it.",
        ],
      },
      {
        heading: "The first thirty days",
        paragraphs: [
          "Days one to ten are logistics — finding the leak points in your routine. By day twenty most members report the mirror test changing: less morning puffiness, sharper shadows. By day thirty the protocol stops feeling like a diet and starts feeling like the default. That is the entire trick. Make the right thing normal.",
        ],
      },
    ],
  },
  {
    slug: "masseter-hypertrophy",
    title: "Masseter Hypertrophy: How the Jaw Actually Grows",
    category: "TRAINING",
    readTime: "5 MIN READ",
    image: "jawCard",
    excerpt:
      "The strongest muscle in your body, pound for pound, is sitting on the side of your face doing almost nothing. Here's how to load it.",
    blocks: [
      {
        paragraphs: [
          "The masseter can generate over 70 kilograms of force at the molars. It is, relative to size, the strongest muscle you own. And if you eat the standard modern diet — soft, processed, pre-chewed by a factory — it is also the most undertrained.",
          "Muscle responds to one thing: progressive mechanical tension. Biceps, quads, masseter — the physiology doesn't change because the muscle is on your face. Load it progressively and it grows. A developed masseter widens the gonial angle and carves the jaw-ear line that separates a structured face from a soft one.",
        ],
      },
      {
        heading: "The loading ladder",
        paragraphs: [
          "Weeks one and two are food-only: steak over mince, whole apples over sauce, crusty bread, jerky. Ten deliberate minutes per meal of actually chewing. This builds the base and, more importantly, the habit.",
          "From week three, add dedicated volume: firm chewing gum or mastic resin, ten to twenty minutes daily, increasing roughly five minutes per week until you hold forty. Chew both sides evenly — asymmetry is the enemy of the aesthetic you're building.",
        ],
      },
      {
        heading: "The rules that keep you safe",
        paragraphs: [
          "One: never through pain. Jaw fatigue is normal; joint clicking or pain is a stop signal, not a push-through moment. Two: rest days apply — six days on, one off, like any programme. Three: if you have any history of TMJ disorder, get professional clearance before you load anything.",
          "Track it the way you'd track a lift. Weekly volume, one side-profile photo every four weeks, same light, same angle. The mirror lies daily. Photographs don't.",
        ],
      },
    ],
  },
  {
    slug: "ancestral-chewing-mechanics",
    title: "Ancestral Chewing Mechanics",
    category: "TRAINING",
    readTime: "4 MIN READ",
    image: "manifestoSpot",
    excerpt:
      "Skulls don't lie: pre-industrial humans had wider jaws, straighter teeth and no orthodontists. The difference was on the plate.",
    blocks: [
      {
        paragraphs: [
          "Anthropologists can date a skull by its teeth. Pre-industrial jaws are wide, with room for all thirty-two teeth including wisdom teeth. Post-industrial jaws are narrow, crowded, and come with a multi-billion pound orthodontics industry. Same genetics. Different inputs.",
          "The variable is chewing stress. A child raised on tough, fibrous, resistant food loads the jaw bones during the years they're still growing — and bone, like muscle, shapes itself to the load it's given.",
        ],
      },
      {
        heading: "What this means for an adult",
        paragraphs: [
          "You're past the growth window, but you're not past change. Muscle hypertrophy is available for life, resting tongue posture remodels how the jaw sits at every minute of the day, and facial fat — the thing blurring whatever structure you have — is entirely a dietary variable.",
          "The ancestral lesson isn't that it's too late. It's that the mechanism was never mysterious. Hard food, hard chew, nose breathing, tongue on the roof. Four inputs your ancestors got for free, and you have to choose on purpose.",
        ],
      },
      {
        heading: "The daily baseline",
        paragraphs: [
          "Tongue flat on the palate, teeth lightly touching, lips sealed, breathing through the nose — all day, including sleep. Meals built from food that fights back a little. Forty minutes of deliberate chew volume. That is the ancestral default, reconstructed. Everything else the club teaches is refinement of these four lines.",
        ],
      },
    ],
  },
  {
    slug: "soft-food-soft-face",
    title: "Soft Food, Soft Face",
    category: "MANIFESTO",
    readTime: "5 MIN READ",
    image: "steak",
    excerpt:
      "Ultra-processed food didn't just change waistlines. It changed the architecture of the modern male face. This is the case for fighting back.",
    blocks: [
      {
        paragraphs: [
          "Look at photographs of men from the 1940s — miners, dockers, farmhands. The faces are all structure: defined jaw-neck angles, hollow cheeks, masseters you can see from across the room. These weren't athletes. They were men who ate meat, potatoes and bread with a crust, and chewed every bite of it.",
          "Now look at the modern face. Softer, rounder, puffy under the eyes, jaw dissolving into neck. We tell ourselves it's genetics or age. Usually it's just inputs — repeated ten thousand times.",
        ],
      },
      {
        heading: "The three mechanisms",
        paragraphs: [
          "First, inflammation. Ultra-processed food and industrial oils keep the face chronically waterlogged and swollen, blurring every angle. Second, underuse. Soft food never loads the masseter, so the muscle atrophies and the jaw line retreats. Third, body fat. A caloric surplus of engineered food stores itself, among other places, directly under the jaw.",
          "Three mechanisms, one root: food that needed a factory. Which is why the club's entire nutrition philosophy fits in one sentence — if it needed a factory, it isn't food.",
        ],
      },
      {
        heading: "The counter-attack",
        paragraphs: [
          "Eat food with structure and your face regains its own. Chew with intent and the musculature returns. Delete the industrial oils and the inflammation drains in weeks. None of this is optimisation culture or biohacking. It is subtraction — removing the things that were never supposed to be there.",
          "Your face is a report card. The good news: you're the one grading it, starting with your next meal.",
        ],
      },
    ],
  },
];

export const DAY_TIMELINE = [
  { time: "06:30", title: "Light, water, salt", text: "Sunlight before screens. A pint of water with a pinch of real salt. The day starts with inputs, not feeds." },
  { time: "07:30", title: "First plate", text: "Steak and eggs, or full-fat yoghurt, fruit and honey. Cooked in butter. Nothing from a packet." },
  { time: "13:00", title: "The working lunch", text: "Meat, potatoes, something fermented. If the only option is a meal deal, you planned wrong yesterday." },
  { time: "18:00", title: "Chew volume", text: "Twenty to forty minutes of deliberate hard chewing, then dinner with actual resistance. This is the training session." },
  { time: "22:30", title: "Mouth closed, lights out", text: "Tongue on the roof, nose breathing, phone in another room. Structure is built while you sleep." },
];

export const PRINCIPLES = [
  "If it has a barcode, question it",
  "Chew something hard every day",
  "Tongue on the roof, always",
  "Cook in animal fat or not at all",
  "Photos over mirrors, data over feelings",
  "12-week cycles. No shortcuts",
];
